import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import APICom from "../../../../utils/helpers/APICom";
import ConfirmationModal from "../../../Controls/ConfirmationModal";



const PickedUp = (props) => {


    const { loginData } = useSelector((store) => store.login);
    const { ASCSSettingData, BrokerServingAffiliatesData } = useSelector((store) => store.combinedata);
    const [showPickedUpAlert, setPickedUpAlert] = useState(false);
    const [pickedupAlertObj, setPickedupAlertObj] = useState({ alertTitle: '', alertMsg: '' });
    const [dispatchMethod, setDispatchMethod] = useState(0);
    const [allowableTimeTripActions, setAllowableTimeTripActions] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [modalBodyText, setModalBodyText] = useState('');

    const allowableTimeRef = useRef(0);
    const dispatchMethodRef = useRef(0);


    const handleShowModal = () => {
        try {
            setShowModal(true);
        } catch (error) {
            console.error("Error: handleShowModal, " + error);
        }
    };

    const handleCloseModal = () => {
        try {
            setShowModal(false);
            UnMountPickedUpComponent()

        } catch (error) {
            console.error("Error: handleCloseModal, " + error);
        }

    };
    const handleOkModal = async () => {
        try {
            setShowModal(false);
            await PerformManualPickedUp();
        } catch (error) {
            console.error("Error: handleOkModal, " + error);
        }
    };

    const getFilteredAffiliates = (gridData) => {
        let filteredAffiliates = [];
        try {
            filteredAffiliates = BrokerServingAffiliatesData?.filter(
                (aff) => String(aff?.iBrokerAffiliateID) === String(gridData?.iSRATSPID)
            );
        }
        catch (e) {
            console.error("Error: getFilteredAffiliates, " + e);
        }
        return filteredAffiliates;
    }

    function convertTo24HourFormat(dateStr) {
        try {
            let [date, timeWithPeriod] = dateStr.trim().split(/\s+/);
            let [month, day, year] = date.split('/');
            let [time, period] = timeWithPeriod.split(/(AM|PM)/);

            let [hours, minutes] = time.split(':');
            if (period === "PM" && hours < 12) {
                hours = parseInt(hours) + 12;
            }
            if (period === "AM" && hours == 12) {
                hours = 0;
            }
            hours = hours.toString().padStart(2, '0');
            minutes = minutes.padStart(2, '0');
            let isoFormattedDate = `${year}-${month}-${day}T${hours}:${minutes}:00`;

            return isoFormattedDate;
        } catch (error) {
            console.error("Error: convertTo24HourFormat, " + error);
            return dateStr;
        }

    }
    useEffect(() => {
        let isMounted = true;
        const executePickedUpLogic = async () => {
            if (!isMounted) { return; }
            if (!props.GridRowData || props.GridRowData.length === 0) {
                setPickedupAlertObj(pickedupAlertObj => ({
                    ...pickedupAlertObj, alertTitle: 'No trip selected',
                    alertMsg: 'No request selected to perform PICKEDUP.'
                }));
                setPickedUpAlert(true);
                return;
            }

            const grdData = props.GridRowData[0];
            let runPerformManualPickedUp = false;
            let filteredAffiliates = [];
            filteredAffiliates = getFilteredAffiliates(grdData);

            if (filteredAffiliates?.length > 0) {
                setPickedupAlertObj(pickedupAlertObj => ({
                    ...pickedupAlertObj, alertTitle: 'Action Restriction',
                    alertMsg: `The trip is assigned to an Affiliate (${grdData?.Affiliate}) and only Affiliate can initiate this action.`
                }));
                setPickedUpAlert(true);
            }
            else if (grdData?.iServiceStatusID !== "3") {
                setPickedupAlertObj(pickedupAlertObj => ({
                    ...pickedupAlertObj, alertTitle: 'Invalid Action',
                    alertMsg: "Action not allowed on un-dispatched trip."
                }));
                setPickedUpAlert(true);
            }
            else if (grdData?.TripRequestStatus.toLowerCase() === "cancelled") {
                setPickedupAlertObj(pickedupAlertObj => ({
                    ...pickedupAlertObj, alertTitle: 'Invalid Action',
                    alertMsg: "Cannot perform Pickedup action on 'CANCELLED' trip."
                }));
                setPickedUpAlert(true);
            }
            else if (grdData?.TripRequestStatus.toLowerCase() === "pickedup" || grdData?.TripRequestStatus.toLowerCase() === "dropped") {
                setPickedupAlertObj(pickedupAlertObj => ({
                    ...pickedupAlertObj, alertTitle: 'Invalid Action',
                    alertMsg: "Request '" + grdData?.ConfirmationNo + "' is already '" + grdData?.TripRequestStatus + "'."
                }));
                setPickedUpAlert(true);
            }
            else if (grdData?.TripRequestStatus.toLowerCase() === "atlocation") {
                await TripRequestStatusAsAtLocation();
            }
            else {
                setPickedupAlertObj(pickedupAlertObj => (
                    {
                        ...pickedupAlertObj, alertTitle: 'Action Restriction',
                        alertMsg: "'" + grdData?.ConfirmationNo + "' cannot be marked as Picked Up. Trip state is not AT-Location."
                    }));
                setPickedUpAlert(true);
            }
        };
        executePickedUpLogic();

        return () => {
            isMounted = false;
            props.setPickedUpProcessing(false);
            props.setPickedUpComponentLoad(false);
        };

    }, []);

    const SetDataFromASCSSettings = () => {
        try {
            if (ASCSSettingData !== null && ASCSSettingData !== undefined && props.GridRowData?.[0]?.iSRATSPID) {
                const iSRATSPID = props.GridRowData[0]?.iSRATSPID;
                if (ASCSSettingData.hasOwnProperty(iSRATSPID)) {
                    const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[iSRATSPID]);
                    ascsSettingDataByAffiliate?.forEach(({ SubTitle, value }) => {
                        if (SubTitle === "DispatchMethod") {
                            setDispatchMethod(value);
                            dispatchMethodRef.current = value;
                        }
                        if (SubTitle === "AllowableTimeTripActions") {
                            setAllowableTimeTripActions(value);
                            allowableTimeRef.current = value;
                        }
                    });
                }
            }
        } catch (error) {
            console.error("Error: PickedUp -> SetDataFromASCSSettings, " + error);
        }
    }

    const TripRequestStatusAsAtLocation = async () => {
        try {
            SetDataFromASCSSettings();
            const pickupDateTimeStr = props.GridRowData?.[0]?.PickupDateTime;
            if (!pickupDateTimeStr) {
                setPickedupAlertObj(pickedupAlertObj => ({ ...pickedupAlertObj, alertTitle: 'PickedUp DateTime Missing', alertMsg: "Action failed." }));
                setPickedUpAlert(true);
                console.error("Error: PickupDateTime is missing.");
                return;
            }

            let isoDateString = convertTo24HourFormat(pickupDateTimeStr);
            let pickUpDateTimeObj = new Date(isoDateString);

            if (isNaN(pickUpDateTimeObj.getTime())) {
                console.error("Error: Invalid pickup date.");
                //setPickedupAlertObj(pickedupAlertObj => ({ ...pickedupAlertObj, alertTitle: 'Invalid DateTime', alertMsg: "Action failed." }));
                //setPickedUpAlert(true);
                handleShowModal();
                return;
            }

            pickUpDateTimeObj.setMinutes(pickUpDateTimeObj.getMinutes() - (parseInt(allowableTimeRef.current, 10) || 0));

            let minimumPickDateTimeObj = new Date(pickUpDateTimeObj)
            let currentDateTime = new Date();

            let timeDifference = Math.abs(currentDateTime - minimumPickDateTimeObj)
            let differenceInMinutes = Math.floor(timeDifference / (1000 * 60));

            if (currentDateTime < minimumPickDateTimeObj) {
                let message = ''
                let hours = Math.floor(differenceInMinutes / 60);
                let minutes = differenceInMinutes % 60;
                message = differenceInMinutes > 60
                    ? `This trip is scheduled to be picked-up in over ${hours} hours and ${minutes} minutes. Marking it as 'Picked Up' seems too early. Do you want to continue?`
                    : `This trip is scheduled to be picked-up in over ${differenceInMinutes} minutes. Marking it as 'Picked Up' seems too early. Do you want to continue?`;
                setModalBodyText(message);
                handleShowModal();

            } else {
                await PerformManualPickedUp();
            }
        } catch (error) {
            console.error("Error: PickedUp, " + error);
            handleShowModal();
            return;
        }
    }


    const PerformManualPickedUp = async () => {
        try {
            if (!props.GridRowData || props.GridRowData.length === 0) return;

            const gData = props.GridRowData[0];
            let Param = {
                "iServiceID": gData.ServiceID,
                "DispatchedBy": dispatchMethodRef.current,
                "iRefID": gData.ConfirmationNo,
                "iUserID": loginData.iUserID
            }
            try {
                let response = await APICom.fetchData("", "TripActions/PerformManualPickedUp", "post", { "Content-Type": "application/json" }, Param, null);
                let result = response.data;
                if (result.count > 0) {
                    setPickedupAlertObj(pickedupAlertObj => ({ ...pickedupAlertObj, alertTitle: 'PickedUp Action', alertMsg: "Action performed successfully." }));
                    setPickedUpAlert(true);
                    props.GridRowData[0].TripRequestStatus = 'PICKEDUP'
                }
                else {
                    setPickedupAlertObj(pickedupAlertObj => ({ ...pickedupAlertObj, alertTitle: 'PickedUp Failed', alertMsg: "Action failed." }));
                    setPickedUpAlert(true);
                }
            } catch (error) {
                console.error("Error in PerformManualPickedUp:", error);
            }
        } catch (error) {
            console.error("Error in PerformManualPickedUp_outer:", error);
        }
    }

    const handlePickedUpAlertClose = () => {
        try {
            setPickedUpAlert(false);
            UnMountPickedUpComponent();
        } catch (error) {
            console.error("Error in handlePickedUpAlertClose:", error);
        }
    }

    const UnMountPickedUpComponent = () => {
        try {
            if (props.pickedupComponentLoaded) {
                props.setPickedUpProcessing(false);
                props.setPickedUpComponentLoad(false);
            }
        } catch (error) {
            console.error("Error in UnMountPickedUpComponent:", error);
        }
    }

    return (
        <>
            {showPickedUpAlert && <Modal centered show={showPickedUpAlert} onHide={handlePickedUpAlertClose} animation={false} >
                <Modal.Header className='activate_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
                    <Modal.Title className='activate_dialog_title_color'>{pickedupAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{pickedupAlertObj.alertMsg}</b></Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handlePickedUpAlertClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            {showModal ? <ConfirmationModal show={true} Title={'Mark Picked Up Warning'} Body={modalBodyText} btnCanceText={'Cancel'} btnOkText={'Mark Picked Up'} ShowCancelButton={true} onOk={handleOkModal} onCancel={handleCloseModal} /> : ""}
        </>
    );

};

export default PickedUp;